import { computed } from "aaa";
import externalInterfaceStore from "stores/ExternalInterfaceStore";


export class AppBusinessStoreRedirectStore {
    private static readonly playStoreUrl = "https://play.google.com/store/apps/details?id=at.erstebank.george.business";
    private static readonly appStoreUrl = "https://apps.apple.com/at/app/george-business-%C3%B6sterreich/id6443934239";
    private static readonly appGalleryUrl = "https://appgallery.huawei.com/app/C107376343";


    @computed get iosStoreUrl(): string {
        if (externalInterfaceStore.isGeorgeApp) {
            return `georgeapp://at/open_external_link?url=${encodeURIComponent(AppBusinessStoreRedirectStore.appStoreUrl)}`;
        }

        return AppBusinessStoreRedirectStore.appStoreUrl;
    }

    @computed get androidStoreUrl(): string {
        if (externalInterfaceStore.isGeorgeApp) {
            return `georgeapp://at/open_external_link?url=${encodeURIComponent(AppBusinessStoreRedirectStore.playStoreUrl)}`;
        }

        return AppBusinessStoreRedirectStore.playStoreUrl;
    }

    @computed get appGalleryStoreUrl(): string {
        if (externalInterfaceStore.isGeorgeApp) {
            return `georgeapp://at/open_external_link?url=${encodeURIComponent(AppBusinessStoreRedirectStore.appGalleryUrl)}`;
        }

        return AppBusinessStoreRedirectStore.appGalleryUrl;
    }
}



// WEBPACK FOOTER //
// ./src/components/appBusinessStoreRedirect/AppBusinessStoreRedirectStore.ts